<template>
  <div class="scrollStep" ref="scrollRef">
    <div class="card">
      <slot></slot>
    </div>
  </div>
</template>


<script setup>
import { ref, onMounted, onUnmounted } from "vue";
import {onIntersect} from '@/utils/onIntersect';

const observer = ref({});
const scrollRef = ref({});

const props = defineProps({
  callBack: {
    type: Function
  },
  index: {
    type: Number
  }
});

const onEnter = (e) => {
  props.callBack(e);
};

const onExit = () => {
};

// When the component is mounted, start observing
onMounted(() => {
  observer.value = onIntersect(scrollRef.value, onEnter, onExit, false, {
    threshold: 1,
  });

  const observer2 = new IntersectionObserver( 
      ([e]) => {
        e.target.classList.toggle('is-top', e.boundingClientRect.top < 0)
      },  
      {threshold: [1]}
    );

    let el = scrollRef.value;

    observer2.observe(el)

});

// When the component is removed, disconnect the observer (clean-up step)
onUnmounted(() => {
  observer.value.disconnect();
});
</script>

<style lang="scss">
.scrollStep {
  display: grid;
  min-height: 1px;
  width: 100%;
  // height: 60vh;
  place-items: center end;
}

.card {
  display: inline-flex;

  align-items: end;
  justify-content: center;
  flex-direction: column;

  p:last-of-type {
    margin-bottom: 0;
  }
}
</style>